import { CloseIcon } from 'asset/icons';
import Modal from "react-bootstrap/Modal";
import React from 'react'
import Loader from 'component/loader';

const ConfirmNetworkModal = ({ show, setShow, loader, handleUpdateUser, currentTab }) => {
    return (
        <Modal
            show={show?.show}
            contentClassName="!rounded-xl w-full max-w-[450px] mx-auto"
            centered
        >
            <Modal.Header className="p-2">
                <div className="cursor-pointer">
                    <CloseIcon
                        onClick={() => {
                            setShow(null, false);
                        }}
                        className="ml-auto size-4"
                    />
                </div>
            </Modal.Header>
            <Modal.Body className="flex flex-col items-center justify-start space-y-1">
                <h6 className="mb-5 text-base font-medium text-center">
                    {show?.type === "edit"
                        ? "Are you sure you want to approve this user ?"
                        : `Are you sure you want to ${currentTab === 'pending' ? 'delete' : 'reject'} this user ?`}
                </h6>
                <div className="flex flex-wrap justify-center w-full gap-2">
                    <button
                        disabled={loader}
                        onClick={() => {
                            setShow(null, false);
                        }}
                        className="bg-[#EBE4FF] text-[#6F00FF] w-5/12 p-2 rounded-[8px] border-0 outline-none font-medium"
                    >
                        Cancel
                    </button>

                    <button
                        type="submit"
                        disable={loader}
                        onClick={() => handleUpdateUser(show?.type)}
                        className="bg-[#6F00FF] text-white w-5/12 p-2 font-medium rounded-[8px] border-0 outline-none justify-center items-center flex"
                    >
                        {loader ? <Loader /> :  currentTab === 'pending' ? 'Delete' : show?.type === "edit" ? "Approve"  : "Reject"}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmNetworkModal